export * from './agency-types'
export * from './bond-features'
export * from './corp-debt-ranks'
export * from './corp-features'
export * from './corp-sectors'
export * from './coupon-features'
export * from './coupon-frequencies'
export * from './coupon-months'
export * from './market-types'
export * from './muni-categories'
export * from './muni-environmentals'
export * from './muni-deminimis'
export * from './muni-purposes'
export * from './muni-taxabilities'
export * from './states-territories'
export * from './treasury-types'

export const INV_TYPE_LABELS = {
    'A': 'Agencies',
    'R': 'Pass-Throughs',
    'K': 'Asset-Backed',
    'S': 'CDs',
    'O': 'CMOs',
    'C': 'Corporates',
    'M': 'Municipals',
    'P': 'Preferreds',
    'L': 'Structured Products',
    'T': 'U.S. Treasuries',
}

export const YES_NO = {
    'Y': 'Yes',
    'N': 'No',
}


// WEBPACK FOOTER //
// ./src/twd/values/index.js